// Price alert API — authenticated CRUD for market price alerts.
import axiosClient from './axiosClient';

import { API_ENDPOINTS } from '@/constants';

// ─── Types ──────────────────────────────────────────────────────────────────

export type AlertDirection = 'above' | 'below';
export type AlertStatus = 'active' | 'triggered' | 'cancelled';

export interface PriceAlert {
  id: number;
  marketId: string | null;
  marketSlug: string | null;
  tokenId: string;
  question: string | null;
  outcome: string | null;
  threshold: string | number; // stored as decimal 0..1
  direction: AlertDirection;
  status: AlertStatus;
  lastPrice: string | number | null;
  triggeredAt: string | null;
  createdAt: string;
}

export interface CreateAlertPayload {
  tokenId: string;
  threshold: number; // 0..1
  direction: AlertDirection;
  marketId?: string | null;
  marketSlug?: string | null;
  question?: string | null;
  outcome?: string | null;
}

// ─── API ────────────────────────────────────────────────────────────────────

export const alertApi = {
  getAlerts: async (): Promise<PriceAlert[]> => {
    const { data } = await axiosClient.get<{ success: boolean; data: PriceAlert[] }>(
      API_ENDPOINTS.ALERTS.LIST,
    );
    return data?.data ?? [];
  },

  createAlert: async (payload: CreateAlertPayload): Promise<PriceAlert> => {
    const { data } = await axiosClient.post<{ success: boolean; data: PriceAlert }>(
      API_ENDPOINTS.ALERTS.CREATE,
      payload,
    );
    return data?.data;
  },

  deleteAlert: async (id: number): Promise<boolean> => {
    const { data } = await axiosClient.delete<{ success: boolean }>(
      API_ENDPOINTS.ALERTS.DELETE(id),
    );
    return data?.success ?? false;
  },
};
